import { Job } from "@/models/Job.model";
import {
  AspectRatio,
  Box,
  Container,
  Flex,
  Heading,
  Text,
} from "@radix-ui/themes";
import { FC, JSX } from "react";
import JobOverviewList from "./job.overview.list";
import useViewportWidth from "@/hooks/useViewportWidth";

interface JobOverviewProps {
  jobs: Job[];
}

const JobOverviewUI: FC<JobOverviewProps> = ({ jobs }): JSX.Element => {
  const isMobile = useViewportWidth(768);
  const isTablet = useViewportWidth(1280);

  return (
    <>
      <AspectRatio ratio={isMobile ? 2 / 1 : isTablet ? 5 / 2 : 5 / 1}>
        <Box
          style={{
            objectFit: "cover",
            width: "100%",
            height: "100%",
            backgroundColor: "var(--accent-3)",
          }}
          position="relative"
          maxWidth="100%"
        >
          <Flex direction="column" justify="end" style={{ height: "100%" }}>
            <Container px={{ initial: "4", lg: "0" }} pb="5" height="100%">
              <Flex
                gap="1"
                direction="column"
                wrap="wrap"
                height="100%"
                justify="end"
              >
                <Heading mb="0" as="h1" size="8">
                  Find Jobs
                </Heading>
                <Text as="p" size="3" wrap="wrap">
                  Explore a variety of job opportunities in the gaming industry.
                </Text>
              </Flex>
            </Container>
          </Flex>
        </Box>
      </AspectRatio>
      <Container px={{ initial: "4", lg: "0" }} py="5">
        <JobOverviewList jobs={jobs} />
      </Container>
    </>
  );
};

export default JobOverviewUI;
